import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { upsertCity } from "../thunks/upsertCity";
import { setFetchState } from "../citiesDataReducer";
import { City } from "../types";

export const useCityUpsert = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.listing.cities.fetchState
  );

  const dispatch = useDispatch();
  const dispatchUpsertCity = React.useCallback(
    (city: City) => dispatch(upsertCity(city)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchUpsertCity] as [
    typeof fetchState,
    typeof dispatchUpsertCity
  ];
};
